import Handlebars from "handlebars/dist/handlebars";

/* eslint-disable prefer-destructuring */
const Algoliasearch = window.algoliasearch;
const Bloodhound = window.Bloodhound;
const jQuery = window.jQuery;
/* eslint-enable prefer-destructuring */

/**
 * 検索サジェストコンポーネント
 *
 * Typeahead.jsをラップして、任意のデータソースを利用したサジェスト機能を
 * 提供します。
 *
 * Examples
 *
 *   new SearchSuggestion({
 *     inputElement: document.getElementById('...'),
 *     dataSource: new AlgoliaDataSource(...),
 *     templateIds: {
 *       empty: 'foo',
 *       footer: 'bar',
 *       suggestion: 'baz'
 *     }
 *   });
 */
export class SearchSuggestion {
  /**
   * Public: コンストラクタ
   *
   * options - 以下のようなプロパティを持つオブジェクト。
   *           inputElement - INPUT DOM Element for typeahead.js
   *           dataSource - getSource関数を持つデータソースオブジェクト。
   *           templateIds
   *             empty      - サジェスト項目が無い場合のHandlebarsテンプレートとなる
   *                          SCRIPT要素のセレクタ。
   *             footer     - ID selector for footer template
   *             suggestion - サジェスト項目のHandlebarsテンプレートとなる
   *                          SCRIPT要素のセレクタ。
   */
  constructor(options) {
    this.options = options;
  }

  init() {
    this.$input = jQuery(this.options.inputElement);
    this.compileTemplates();
    this.initTypeahead();
    this.bindEvents();
  }

  compileTemplates() {
    const source1 = document.getElementById(
      this.options.templateIds.empty,
    ).innerHTML;
    const source2 = document.getElementById(
      this.options.templateIds.footer,
    ).innerHTML;
    const source3 = document.getElementById(
      this.options.templateIds.suggestion,
    ).innerHTML;
    this.compiledEmptyTemplate = Handlebars.compile(source1);
    this.compiledFooterTemplate = Handlebars.compile(source2);
    this.compiledSuggestionTemplate = Handlebars.compile(source3);
  }

  initTypeahead() {
    const options = {
      hint: false,
      minLength: 1,
    };
    const dataSet = {
      name: "titles",
      displayKey: "name",
      source: this.options.dataSource.getSource(),
      templates: {
        empty: this.compiledEmptyTemplate,
        footer: this.compiledFooterTemplate,
        suggestion: this.compiledSuggestionTemplate,
      },
    };
    this.$input.typeahead(options, dataSet);
  }

  bindEvents() {
    this.$input.on("typeahead:selected", (_event, suggestion) => {
      window.location.href = `/titles/${suggestion.objectID}`;
    });
  }
}

/**
 * 検索サジェスト用Algoliaデータソース
 */
export class AlgoliaDataSource {
  /**
   * Public: コンストラクタ
   *
   * options - 以下のようなプロパティを持つオブジェクト。
   *           appId - AlgoliaのアプリケーションID。
   *           apiKey - AlgoliaのAPIキー。
   *           indexName - 検索に利用するインデックス名。
   *           limit - 取得する件数の上限（デフォルトは6）。
   */
  constructor(options) {
    this.options = options;
    this.client = new Algoliasearch(this.options.appId, this.options.apiKey);
  }

  getSource() {
    return this.client.initIndex(this.options.indexName).ttAdapter({
      hitsPerPage: this.options.limit || 6,
    });
  }
}

/**
 * 検索サジェスト用PostgreSQLデータソース
 *
 * データソースとして /titles/suggestion.json のレスポンスを利用します。
 * 検索性能は考慮していないため、主にdevelopment環境での動作確認用です。
 */
export class PostgresqlDataSource {
  constructor() {
    this.titles = new Bloodhound({
      name: "titles",
      remote: "/titles/suggestion.json?keyword=%QUERY",
      datumTokenizer: (datum) => Bloodhound.tokenizers.whitespace(datum.name),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
    });
    this.titles.initialize();
  }

  getSource() {
    return this.titles.ttAdapter();
  }
}
